import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import moment from "moment-timezone"
import {get} from "lodash"
import styled from "styled-components"

import {FormattedDate} from "@irati/utils/lang"

import {Para} from "../../../ui/Labels"

const StyledPara = styled(Para)`
  display: flex;
  justify-content: flex-end;
`


class DateCellRenderer extends PureComponent {
  static propTypes = {
    row: PropTypes.object.isRequired,
    property: PropTypes.string.isRequired
  }

  render() {
    const {row, property} = this.props
    return (
      <StyledPara medium flush>
        <FormattedDate value={moment(get(row, property))} month="numeric" day="numeric" year="numeric" />
      </StyledPara>
    )
  }
}

export default DateCellRenderer
